import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentationService } from '../services/documentation.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as $ from "jquery";
import { ViewportScroller } from '@angular/common';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { DownloadService } from '../services/download.service';
import { HttpResponse } from '@angular/common/http';


@Component({
  selector: 'app-documentationview',
  templateUrl: './documentation-view.component.html',
  styleUrls: ['./documentation-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('FadeAnimation', [

      state('in', style({ opacity: 1 })),

      transition(':enter', [
        style({ opacity: 0 }),
        animate(100)
      ]),

      transition(':leave',
        animate(100, style({ opacity: 0 })))
    ])
  ]
})

export class DocumentationViewComponent implements OnInit {

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY > 135) {
      this.activateGoTop = true;
    } else {
      this.activateGoTop = false;
    }
  }

  constructor(private router: Router,
    private documentationService: DocumentationService,
    private viewportScroller: ViewportScroller,
    private downloadService: DownloadService) { }

  path = this.router.url;
  data: any;
  loading: boolean = true;
  activateGoTop: boolean;
  contentIndexList: HTMLCollection;
  downloadIndexList: HTMLCollection;

  ngOnInit() {
    this.activateGoTop = false;
    var route = {
      "documentationName": this.path
    }

    this.documentationService.getDocumentation(route).subscribe(
      Documentation => {
        this.data = Documentation
        this.loading = false;
        this.contentIndexList = document.getElementsByClassName("indexItem");
        this.downloadIndexList = document.getElementsByClassName("downloadLink");
        if(this.data.includes('Documentation could not be found.')){
          
          this.data = '<div class="center"><h1>404</h1><h2 class="center">Documentation not found</h2></div>'
        }
      },
      Err => {
        console.log("Documentation Failed")
      }
    )
  }


  public ScrollToElement(elementId: string): void {
    var id = elementId.replace(/\s+/g, '');

    if (document.getElementById(id) != null) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
    else {
      console.log("ID not found");
    }
  }

  download(id: string) {
    var route = {
      "downloadName": id
    }

    this.downloadService.getDownload(route)
      .subscribe((response: HttpResponse<Blob>) => {
        let filename: string = this.getFileName(response)
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      })
  }

  getFileName(response: HttpResponse<Blob>) {
    var contentDispositionHeader = response.headers.get('Content-Disposition');
    var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    return result.replace(/"/g, '');
  }


}
